import { GeneralError } from '@dxp-module/common'
import { createContext, Dispatch, SetStateAction } from 'react'

type CalculatorErrorContextProps = {
  calculatorErrorState: [
    GeneralError | null,
    Dispatch<SetStateAction<GeneralError | null>>
  ]
}

const CalculatorErrorContext =
  createContext<CalculatorErrorContextProps | null>(null)

export default CalculatorErrorContext
